import NewTabIcon from './NewTabIcon'

export default NewTabIcon
